import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '../utils';

const Breadcrumbs = ({ items = [], className }) => {
  return (
    <nav className={cn("flex items-center gap-2 text-xxs font-bold text-gray-400 uppercase tracking-widest overflow-hidden", className)}>
      <Link 
        to="/" 
        className="hover:text-brand-indigo transition-colors flex items-center shrink-0"
        title="Home"
      >
        <Home size={12} />
      </Link>
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight size={10} className="shrink-0 text-gray-300" />
          {item.path ? (
            <Link 
              to={item.path} 
              className={cn(
                "hover:text-brand-indigo transition-colors truncate",
                index === items.length - 1 ? "text-brand-indigo" : ""
              )}
              style={item.maxWidth ? { maxWidth: item.maxWidth } : { maxWidth: '120px' }}
            >
              {item.label}
            </Link>
          ) : (
            <span 
              className={cn(
                "truncate",
                index === items.length - 1 ? "text-brand-indigo" : ""
              )}
              style={item.maxWidth ? { maxWidth: item.maxWidth } : { maxWidth: '120px' }}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
